import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "font-sans font-bold break-normal text-gray-700 px-2 pb-2" }, " サロン追加 ", -1)
const _hoisted_2 = { class: "p-2 mt-2 lg:mt-0 rounded shadow bg-white" }
const _hoisted_3 = { class: "p-6" }
const _hoisted_4 = { class: "mb-2 last:mb-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, [
  /*#__PURE__*/_createTextVNode("サロン名"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs align-text-top text-red-600 ml-2" }, "必須")
], -1)
const _hoisted_6 = { class: "grid grid-cols-1 gap-3 md:grid-cols-2" }
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = { class: "text-xs text-pink-600" }
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = { class: "text-xs text-pink-600" }
const _hoisted_11 = { class: "relative" }
const _hoisted_12 = { class: "text-xs text-pink-600" }
const _hoisted_13 = { class: "mb-2 last:mb-0" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, [
  /*#__PURE__*/_createTextVNode("住所"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs align-text-top text-red-600 ml-2" }, "必須")
], -1)
const _hoisted_15 = { class: "grid grid-cols-1 gap-3 md:grid-cols-3 mb-2" }
const _hoisted_16 = { class: "relative" }
const _hoisted_17 = { class: "text-xs text-pink-600" }
const _hoisted_18 = { class: "relative" }
const _hoisted_19 = { class: "relative" }
const _hoisted_20 = { class: "text-xs text-pink-600" }
const _hoisted_21 = { class: "grid grid-cols-1 gap-3 md:grid-cols-2" }
const _hoisted_22 = { class: "relative" }
const _hoisted_23 = { class: "text-xs text-pink-600" }
const _hoisted_24 = { class: "relative" }
const _hoisted_25 = { class: "text-xs text-pink-600" }
const _hoisted_26 = { class: "mb-2 last:mb-0" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, [
  /*#__PURE__*/_createTextVNode("連絡先"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs align-text-top text-red-600 ml-2" }, "必須")
], -1)
const _hoisted_28 = { class: "grid grid-cols-1 gap-3 md:grid-cols-2" }
const _hoisted_29 = { class: "relative" }
const _hoisted_30 = { class: "text-xs text-pink-600" }
const _hoisted_31 = { class: "mb-2 last:mb-0" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, [
  /*#__PURE__*/_createTextVNode("代理店"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs align-text-top text-red-600 ml-2" }, "必須")
], -1)
const _hoisted_33 = { class: "relative" }
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "text-xs text-pink-600" }
const _hoisted_36 = {
  key: 0,
  class: "p-2 mt-2 rounded shadow bg-white"
}
const _hoisted_37 = { class: "p-6" }
const _hoisted_38 = { class: "mb-2 last:mb-0" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, [
  /*#__PURE__*/_createTextVNode("店舗名"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs align-text-top text-red-600 ml-2" }, "必須")
], -1)
const _hoisted_40 = { class: "grid grid-cols-1 gap-3 md:grid-cols-2" }
const _hoisted_41 = { class: "relative" }
const _hoisted_42 = { class: "text-xs text-pink-600" }
const _hoisted_43 = { class: "relative" }
const _hoisted_44 = { class: "text-xs text-pink-600" }
const _hoisted_45 = { class: "mb-2 last:mb-0" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, [
  /*#__PURE__*/_createTextVNode("住所"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs align-text-top text-red-600 ml-2" }, "必須")
], -1)
const _hoisted_47 = { class: "form-check mb-2" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label inline-block text-gray-800",
  for: "form_same_as_salon_address"
}, " サロンの住所と一緒 ", -1)
const _hoisted_49 = { class: "grid grid-cols-1 gap-3 md:grid-cols-3 mb-2" }
const _hoisted_50 = { class: "relative" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = { class: "text-xs text-pink-600" }
const _hoisted_53 = { class: "relative" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { class: "text-xs text-pink-600" }
const _hoisted_56 = { class: "relative" }
const _hoisted_57 = ["disabled"]
const _hoisted_58 = { class: "text-xs text-pink-600" }
const _hoisted_59 = { class: "grid grid-cols-1 gap-3 md:grid-cols-2" }
const _hoisted_60 = { class: "relative" }
const _hoisted_61 = ["disabled"]
const _hoisted_62 = { class: "text-xs text-pink-600" }
const _hoisted_63 = { class: "relative" }
const _hoisted_64 = ["disabled"]
const _hoisted_65 = { class: "text-xs text-pink-600" }
const _hoisted_66 = { class: "mb-2 last:mb-0" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, [
  /*#__PURE__*/_createTextVNode("連絡先"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs align-text-top text-red-600 ml-2" }, "必須")
], -1)
const _hoisted_68 = { class: "grid grid-cols-1 gap-3 md:grid-cols-2" }
const _hoisted_69 = { class: "relative" }
const _hoisted_70 = ["disabled"]
const _hoisted_71 = { class: "text-xs text-pink-600" }
const _hoisted_72 = { class: "p-2 mt-2 rounded shadow bg-white" }
const _hoisted_73 = { class: "p-6" }
const _hoisted_74 = { class: "mb-2 last:mb-0" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, [
  /*#__PURE__*/_createTextVNode("振込先"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs align-text-top text-red-600 ml-2" }, "必須")
], -1)
const _hoisted_76 = { class: "grid grid-cols-1 gap-3 md:grid-cols-2 mb-2" }
const _hoisted_77 = { class: "relative" }
const _hoisted_78 = {
  key: 0,
  class: "w-full rounded bg-white border border-gray-300 px-4 py-2 space-y-1 absolute z-10"
}
const _hoisted_79 = ["onClick"]
const _hoisted_80 = { class: "text-xs text-pink-600" }
const _hoisted_81 = { class: "relative" }
const _hoisted_82 = {
  key: 0,
  class: "w-full rounded bg-white border px-4 py-2 space-y-1 absolute z-10"
}
const _hoisted_83 = ["onClick"]
const _hoisted_84 = { class: "text-xs text-pink-600" }
const _hoisted_85 = { class: "grid grid-cols-1 gap-3 md:grid-cols-2 mb-2" }
const _hoisted_86 = { class: "relative mt-2" }
const _hoisted_87 = { class: "inline-flex items-center" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "普通", -1)
const _hoisted_89 = { class: "inline-flex items-center ml-6" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "当座", -1)
const _hoisted_91 = { class: "inline-flex items-center ml-6" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "貯蓄", -1)
const _hoisted_93 = { class: "text-xs text-pink-600" }
const _hoisted_94 = { class: "relative" }
const _hoisted_95 = { class: "text-xs text-pink-600" }
const _hoisted_96 = { class: "grid grid-cols-1 gap-3 md:grid-cols-2" }
const _hoisted_97 = { class: "relative" }
const _hoisted_98 = { class: "text-xs text-pink-600" }
const _hoisted_99 = {
  key: 1,
  class: "p-2 mt-2 rounded shadow bg-white"
}
const _hoisted_100 = { class: "p-6" }
const _hoisted_101 = { class: "mb-2 last:mb-0" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, [
  /*#__PURE__*/_createTextVNode("管理者名"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs align-text-top text-red-600 ml-2" }, "必須")
], -1)
const _hoisted_103 = { class: "grid grid-cols-1 gap-3 md:grid-cols-2 mb-2" }
const _hoisted_104 = { class: "relative" }
const _hoisted_105 = { class: "text-xs text-pink-600" }
const _hoisted_106 = { class: "relative" }
const _hoisted_107 = { class: "text-xs text-pink-600" }
const _hoisted_108 = { class: "grid grid-cols-1 gap-3 md:grid-cols-2 mb-2" }
const _hoisted_109 = { class: "relative" }
const _hoisted_110 = { class: "text-xs text-pink-600" }
const _hoisted_111 = { class: "text-right col-span-full mt-4 pb-8" }
const _hoisted_112 = ["onClick"]
const _hoisted_113 = {
  key: 0,
  class: "flex p-4 mt-4 mb-4 bg-red-100 rounded-lg dark:bg-red-200",
  role: "alert"
}
const _hoisted_114 = /*#__PURE__*/_createElementVNode("svg", {
  class: "flex-shrink-0 w-5 h-5 text-red-700 dark:text-red-800",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_115 = { class: "ml-3 text-sm font-medium text-red-700 dark:text-red-800" }

import { FieldContext, useField, useForm } from "vee-validate";
import * as yup from "yup";

import { PREFECTURES } from "@/utils/prefectures";
import Dealer from "@/models/Dealer";
import Salon from "@/models/Salon";
import Bank from "@/models/Bank";
import Branch from "@/models/Branch";
import Prefecture from "@/models/Prefecture";
import AddressUtil from "@/utils/AddressUtil";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'SalonEdit',
  setup(__props) {

const message = ref<string | null>(null);

const store = useStore();
const route = useRoute();
const router = useRouter();

const formSchema = yup.object({
  selected_dealer_id: yup.string().required("必須項目です"),
  salon_name: yup.string().required("必須項目です"),
  salon_display_name: yup.string().required("必須項目です"),
  salon_kana: yup.string().kana().required("必須項目です"),
  postcode: yup.string().postcode().required("必須項目です"),
  prefecture: yup.string().required("必須項目です"),
  city: yup.string().required("必須項目です"),
  address: yup.string().required("必須項目です"),
  building: yup.string(),
  telephone: yup.string().phonenumber().required("必須項目です"),
  // email: yup.string().email().required("必須項目です"),
  same_as_salon_address: yup.boolean(),
  shop_name: yup.string().required("必須項目です"),
  shop_kana: yup.string().kana().required("必須項目です"),
  shop_postcode: yup
    .string()
    .postcode()
    .when("same_as_salon_address", {
      is: false,
      then: yup.string().postcode().required("必須項目です"),
    }),
  shop_prefecture: yup.string().when("same_as_salon_address", {
    is: false,
    then: yup.string().required("必須項目です"),
  }),
  shop_city: yup.string().when("same_as_salon_address", {
    is: false,
    then: yup.string().required("必須項目です"),
  }),
  shop_address: yup.string().when("same_as_salon_address", {
    is: false,
    then: yup.string().required("必須項目です"),
  }),
  shop_building: yup.string(),
  shop_telephone: yup
    .string()
    .phonenumber()
    .when("same_as_salon_address", {
      is: false,
      then: yup.string().required("必須項目です"),
    }),
  account_type: yup.string().required("必須項目です"),
  account_no: yup.string().accountno().required("必須項目です"),
  account_name: yup.string().kana().required("必須項目です"),
  administrator_name: yup.string().required("必須項目です"),
  administrator_kana: yup.string().kana().required("必須項目です"),
  administrator_email: yup.string().email().required("必須項目です"),
});

useForm({ validationSchema: formSchema });

const selected_dealer_id_field = useField<string>("selected_dealer_id");
const salon_name_field = useField<string>("salon_name");
const salon_display_name_field = useField<string>("salon_display_name");
const salon_kana_field = useField<string>("salon_kana");
const postcode_field = useField<string>("postcode");
const prefecture_field = useField<string>("prefecture");
const city_field = useField<string>("city");
const address_field = useField<string>("address");
const building_field = useField<string>("building");
const telephone_field = useField<string>("telephone");
// const email = useField<string>("email");
const same_as_salon_address_field = useField<boolean>("same_as_salon_address");
const shop_name_field = useField<string>("shop_name");
const shop_kana_field = useField<string>("shop_kana");
const shop_postcode_field = useField<string>("shop_postcode");
const shop_prefecture_field = useField<string>("shop_prefecture");
const shop_city_field = useField<string>("shop_city");
const shop_address_field = useField<string>("shop_address");
const shop_building_field = useField<string>("shop_building");
const shop_telephone_field = useField<string>("shop_telephone");
const account_type_field = useField<string>("account_type");
const account_no_field = useField<string>("account_no");
const account_name_field = useField<string>("account_name");
const administrator_name_field = useField<string>("administrator_name");
const administrator_kana_field = useField<string>("administrator_kana");
const administrator_email_field = useField<string>("administrator_email");

const prefectures = ref<string[]>(PREFECTURES);

const salon = ref<Salon | null>(null);

const dealers = ref<Dealer[]>([]);

const selected_dealer_id = selected_dealer_id_field.value;
const selected_dealer_id_error = selected_dealer_id_field.errorMessage;

const salon_name = salon_name_field.value;
const salon_name_error = salon_name_field.errorMessage;

const salon_kana = salon_kana_field.value;
const salon_kana_error = salon_kana_field.errorMessage;

const salon_display_name = salon_display_name_field.value;
const salon_display_name_error = salon_display_name_field.errorMessage;

const postcode = postcode_field.value;
const postcode_error = postcode_field.errorMessage;

const prefecture = prefecture_field.value;
const prefecture_error = prefecture_field.errorMessage;

const city = city_field.value;
const city_error = city_field.errorMessage;

const address = address_field.value;
const address_error = address_field.errorMessage;

const building = building_field.value;
const building_error = building_field.errorMessage;

const telephone = telephone_field.value;
const telephone_error = telephone_field.errorMessage;

const shop_name = shop_name_field.value;
const shop_name_error = shop_name_field.errorMessage;

const shop_kana = shop_kana_field.value;
const shop_kana_error = shop_kana_field.errorMessage;

const shop_postcode = shop_postcode_field.value;
const shop_postcode_error = shop_postcode_field.errorMessage;

const shop_prefecture = shop_prefecture_field.value;
const shop_prefecture_error = shop_prefecture_field.errorMessage;

const shop_city = shop_city_field.value;
const shop_city_error = shop_city_field.errorMessage;

const shop_address = shop_address_field.value;
const shop_address_error = shop_address_field.errorMessage;

const shop_building = shop_building_field.value;
const shop_building_error = shop_building_field.errorMessage;

const shop_telephone = shop_telephone_field.value;
const shop_telephone_error = shop_telephone_field.errorMessage;

const same_as_salon_address = same_as_salon_address_field.value;

const selected_bank = ref<Bank | null>(null);
const bank_suggests = ref<Bank[]>([]);
const bank_keyword = ref<string>("");
const bank_error = ref<string | null>(null);

const selected_branch = ref<Branch | null>(null);
const branch_suggests = ref<Branch[]>([]);
const branch_keyword = ref<string>("");
const branch_error = ref<string | null>(null);

const account_type = account_type_field.value;
const account_type_error = account_type_field.errorMessage;

const account_no = account_no_field.value;
const account_no_error = account_no_field.errorMessage;

const account_name = account_name_field.value;
const account_name_error = account_name_field.errorMessage;

const administrator_name = administrator_name_field.value;
const administrator_name_error = administrator_name_field.errorMessage;

const administrator_kana = administrator_kana_field.value;
const administrator_kana_error = administrator_kana_field.errorMessage;

const administrator_email = administrator_email_field.value;
const administrator_email_error = administrator_email_field.errorMessage;

const selected_bank_name = computed<string>(() => {
  return selected_bank.value ? selected_bank.value.name : "";
});

onMounted(() => {
  refresh();
});

const refresh = () => {
  if (store.state.is_loading) {
    return;
  }

  const id = route.params.salon_id as string | null;

  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const result = await Dealer.search(null, null, null);

      dealers.value = [];
      result.dealers.forEach((dealer) => {
        if (!dealer.deleted_at) {
          dealers.value.push(dealer);
        }
      });

      if (id) {
        console.log(id);

        salon.value = await Salon.get(id);

        selected_dealer_id.value = salon.value.dealer_id;

        salon_name.value = salon.value.name;
        salon_kana.value = salon.value.kana;
        salon_display_name.value = salon.value.display_name;

        postcode.value = salon.value.postcode;
        prefecture.value = salon.value.prefecture;
        city.value = salon.value.city;
        address.value = salon.value.address;
        building.value = salon.value.building;
        telephone.value = salon.value.telephone;

        // shop_name: "",
        // shop_kana: "",

        // shop_postcode: "",
        // shop_prefecture: "福岡県",
        // shop_city: "",
        // shop_address: "",
        // shop_building: "",
        // shop_telephone: "",

        // same_as_salon_address: true,

        selected_bank.value = new Bank(
          salon.value.bank_code,
          salon.value.bank_name
        );
        bank_keyword.value = salon.value.bank_name;

        selected_branch.value = new Bank(
          salon.value.branch_code,
          salon.value.branch_name
        );
        branch_keyword.value = salon.value.branch_name;

        account_type.value = salon.value.account_type;
        account_no.value = salon.value.account_no;
        account_name.value = salon.value.account_name;
      }
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const onSalonPostcodeChanged = () => {
  console.log(`${postcode} ${postcode_error}`);
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const result = await AddressUtil.search(postcode.value);
      if (!result || result.length == 0) {
        return;
      }
      const data = result[0] as any;
      prefecture.value = Prefecture.all().find((p) => p == data.pref) || "";
      // if (prefecture) {
      //   prefecture_keyword = prefecture;
      // }
      city.value = data.city as string;
      address.value = data.town as string;
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const onShopPostcodeChanged = () => {
  console.log(`${postcode} ${postcode_error}`);
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const result = await AddressUtil.search(shop_postcode.value);
      if (!result || result.length == 0) {
        return;
      }
      const data = result[0] as any;
      shop_prefecture.value = Prefecture.all().find((p) => p == data.pref) || "";
      // if (prefecture) {
      //   prefecture_keyword = prefecture;
      // }
      shop_city.value = data.city as string;
      shop_address.value = data.town as string;
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const onBanknameChanged = (e: Event) => {
  if (!(e.target instanceof HTMLInputElement)) {
    return;
  }
  bank_keyword.value = e.target.value;
  if (store.state.is_loading) {
    return;
  }

  store.dispatch("setLoading", true);

  setTimeout(async () => {
    try {
      if (!bank_keyword.value) {
        return;
      }

      const suggests = await Bank.search(bank_keyword.value);

      bank_suggests.value = suggests;
      console.log(suggests);
    } finally {
      store.dispatch("setLoading", false);
    }
  }, 1000);
};

const onBankSelected = (bank: Bank) => {
  selected_bank.value = bank;
  selected_branch.value = null;
  bank_keyword.value = bank.name;
  bank_suggests.value.length = 0;
};

const onBranchnameChanged = (e: Event) => {
  if (!(e.target instanceof HTMLInputElement)) {
    return;
  }
  branch_keyword.value = e.target.value;
  if (store.state.is_loading) {
    return;
  }

  store.dispatch("setLoading", true);

  setTimeout(async () => {
    try {
      if (!branch_keyword.value) {
        return;
      }
      if (!selected_bank.value) {
        return;
      }

      const suggests = await Branch.search(
        selected_bank.value.code,
        branch_keyword.value
      );

      branch_suggests.value = suggests;
      console.log(suggests);
    } finally {
      store.dispatch("setLoading", false);
    }
  }, 1000);
};

const onBranchSelected = (branch: Branch) => {
  selected_branch.value = branch;
  branch_keyword.value = branch.name;
  branch_suggests.value.length = 0;
};

const validate = async (): Promise<boolean> => {
  bank_error.value = "";
  branch_error.value = "";
  await selected_dealer_id_field.validate();
  await salon_name_field.validate();
  await salon_kana_field.validate();
  await salon_display_name_field.validate();
  await postcode_field.validate();
  await prefecture_field.validate();
  await city_field.validate();
  await address_field.validate();
  await building_field.validate();
  await telephone_field.validate();
  // await email_field.validate();
  await shop_name_field.validate();
  await shop_kana_field.validate();
  await shop_postcode_field.validate();
  await shop_prefecture_field.validate();
  await shop_city_field.validate();
  await shop_address_field.validate();
  await shop_building_field.validate();
  await shop_telephone_field.validate();
  await account_type_field.validate();
  await account_no_field.validate();
  await account_name_field.validate();
  await administrator_name_field.validate();
  await administrator_kana_field.validate();
  await administrator_email_field.validate();

  if (!selected_bank.value) {
    bank_error.value = "銀行を選択してください";
  }

  if (!selected_branch.value) {
    branch_error.value = "支店を選択してください";
  }

  if (salon.value) {
    return (
      !salon_name_error.value &&
      !salon_kana_error.value &&
      !salon_display_name_error.value &&
      !postcode_error.value &&
      !prefecture_error.value &&
      !city_error.value &&
      !address_error.value &&
      !building_error.value &&
      !telephone_error.value &&
      !bank_error.value &&
      !branch_error.value &&
      !account_type_error.value &&
      !account_no_error.value &&
      !account_name_error.value
    );
  }

  return (
    !selected_dealer_id_error.value &&
    !salon_name_error.value &&
    !salon_kana_error.value &&
    !salon_display_name_error.value &&
    !postcode_error.value &&
    !prefecture_error.value &&
    !city_error.value &&
    !address_error.value &&
    !building_error.value &&
    !telephone_error.value &&
    // !email_error &&
    !shop_name_error.value &&
    !shop_kana_error.value &&
    !shop_postcode_error.value &&
    !shop_prefecture_error.value &&
    !shop_city_error.value &&
    !shop_address_error.value &&
    !shop_building_error.value &&
    !shop_telephone_error.value &&
    !bank_error.value &&
    !branch_error.value &&
    !account_type_error.value &&
    !account_no_error.value &&
    !account_name_error.value &&
    !administrator_name_error.value &&
    !administrator_kana_error.value &&
    !administrator_email_error.value
  );
};

const onSave = () => {
  if (store.state.is_loading) {
    return;
  }

  message.value = null;

  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const valid = await validate();
      if (!valid) {
        return;
      }

      if (!selected_dealer_id) {
        return;
      }
      if (!selected_bank.value) {
        return;
      }
      if (!selected_branch.value) {
        return;
      }

      if (!salon.value) {
        await Salon.register(
          selected_dealer_id.value,
          salon_name.value,
          salon_kana.value,
          salon_display_name.value,
          postcode.value,
          prefecture.value,
          city.value,
          address.value,
          building.value,
          telephone.value,
          // email,
          shop_name.value,
          shop_kana.value,
          same_as_salon_address.value ? postcode.value : shop_postcode.value,
          same_as_salon_address.value
            ? prefecture.value
            : shop_prefecture.value,
          same_as_salon_address.value ? city.value : shop_city.value,
          same_as_salon_address.value ? address.value : shop_address.value,
          same_as_salon_address.value ? building.value : shop_building.value,
          same_as_salon_address.value ? telephone.value : shop_telephone.value,
          selected_bank.value!.code,
          selected_bank.value!.name,
          selected_branch.value!.code,
          selected_branch.value!.name,
          account_type.value,
          account_no.value,
          account_name.value,
          administrator_name.value,
          administrator_kana.value,
          administrator_email.value
        );
      } else {
        await Salon.update(
          salon.value.id,
          selected_dealer_id.value,
          salon_name.value,
          salon_kana.value,
          salon_display_name.value,
          postcode.value,
          prefecture.value,
          city.value,
          address.value,
          building.value,
          telephone.value,
          // email,
          selected_bank.value!.code,
          selected_bank.value!.name,
          selected_branch.value!.code,
          selected_branch.value!.name,
          account_type.value,
          account_no.value,
          account_name.value
        );
      }

      router.push(`/salons`);
    } catch (ex) {
      message.value = `${ex}`;
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};
// });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(salon_name_error) }]),
                placeholder: "サロン名",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(salon_name) ? (salon_name).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(salon_name)]
              ]),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(salon_name_error)), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "email",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(salon_kana_error) }]),
                placeholder: "サロン名(カナ)",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(salon_kana) ? (salon_kana).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(salon_kana)]
              ]),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(salon_kana_error)), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(salon_display_name_error) }]),
                placeholder: "サロンアプリ表示名",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(salon_display_name) ? (salon_display_name).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(salon_display_name)]
              ]),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(salon_display_name_error)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(postcode_error) }]),
                placeholder: "郵便番号(XXX-XXXX)",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(postcode) ? (postcode).value = $event : null)),
                onChange: onSalonPostcodeChanged
              }, null, 34), [
                [_vModelText, _unref(postcode)]
              ]),
              _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(postcode_error)), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(prefecture_error) }]),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(prefecture) ? (prefecture).value = $event : null))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prefectures.value, (p) => {
                  return (_openBlock(), _createElementBlock("option", { key: p }, _toDisplayString(p), 1))
                }), 128))
              ], 2), [
                [_vModelSelect, _unref(prefecture)]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(city_error) }]),
                placeholder: "市区町村",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(city) ? (city).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(city)]
              ]),
              _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(city_error)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(address_error) }]),
                placeholder: "番地",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(address) ? (address).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(address)]
              ]),
              _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(address_error)), 1)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("input", {
                type: "email",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(building_error) }]),
                placeholder: "建物",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(building) ? (building).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(building)]
              ]),
              _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(building_error)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(telephone_error) }]),
                placeholder: "電話番号(XXX-XXXX-XXXX)",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(telephone) ? (telephone).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(telephone)]
              ]),
              _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(telephone_error)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(selected_dealer_id_error) }]),
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(selected_dealer_id) ? (selected_dealer_id).value = $event : null))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dealers.value, (dealer) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: dealer.id,
                  value: dealer.id
                }, _toDisplayString(dealer.name), 9, _hoisted_34))
              }), 128))
            ], 2), [
              [_vModelSelect, _unref(selected_dealer_id)]
            ]),
            _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(selected_dealer_id_error)), 1)
          ])
        ])
      ])
    ]),
    (!salon.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(shop_name_error) }]),
                    placeholder: "店舗名",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(shop_name) ? (shop_name).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(shop_name)]
                  ]),
                  _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(shop_name_error)), 1)
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(shop_kana_error) }]),
                    placeholder: "店舗名(カナ)",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(shop_kana) ? (shop_kana).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(shop_kana)]
                  ]),
                  _createElementVNode("span", _hoisted_44, _toDisplayString(_unref(shop_kana_error)), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _hoisted_46,
              _createElementVNode("div", _hoisted_47, [
                _withDirectives(_createElementVNode("input", {
                  class: "mr-2 cursor-pointer",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(same_as_salon_address) ? (same_as_salon_address).value = $event : null))
                }, null, 512), [
                  [_vModelCheckbox, _unref(same_as_salon_address)]
                ]),
                _hoisted_48
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(shop_postcode_error) }]),
                    placeholder: "郵便番号(XXX-XXXX)",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(shop_postcode) ? (shop_postcode).value = $event : null)),
                    onChange: onShopPostcodeChanged,
                    disabled: _unref(same_as_salon_address)
                  }, null, 42, _hoisted_51), [
                    [_vModelText, _unref(shop_postcode)]
                  ]),
                  _createElementVNode("span", _hoisted_52, _toDisplayString(_unref(shop_postcode_error)), 1)
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _withDirectives(_createElementVNode("select", {
                    class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(shop_prefecture_error) }]),
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_isRef(shop_prefecture) ? (shop_prefecture).value = $event : null)),
                    disabled: _unref(same_as_salon_address)
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prefectures.value, (p) => {
                      return (_openBlock(), _createElementBlock("option", { key: p }, _toDisplayString(p), 1))
                    }), 128))
                  ], 10, _hoisted_54), [
                    [_vModelSelect, _unref(shop_prefecture)]
                  ]),
                  _createElementVNode("span", _hoisted_55, _toDisplayString(_unref(shop_prefecture_error)), 1)
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(shop_city_error) }]),
                    placeholder: "市区町村",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_isRef(shop_city) ? (shop_city).value = $event : null)),
                    disabled: _unref(same_as_salon_address)
                  }, null, 10, _hoisted_57), [
                    [_vModelText, _unref(shop_city)]
                  ]),
                  _createElementVNode("span", _hoisted_58, _toDisplayString(_unref(shop_city_error)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(shop_address_error) }]),
                    placeholder: "番地",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(shop_address) ? (shop_address).value = $event : null)),
                    disabled: _unref(same_as_salon_address)
                  }, null, 10, _hoisted_61), [
                    [_vModelText, _unref(shop_address)]
                  ]),
                  _createElementVNode("span", _hoisted_62, _toDisplayString(_unref(shop_address_error)), 1)
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(shop_building_error) }]),
                    placeholder: "建物",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_isRef(shop_building) ? (shop_building).value = $event : null)),
                    disabled: _unref(same_as_salon_address)
                  }, null, 10, _hoisted_64), [
                    [_vModelText, _unref(shop_building)]
                  ]),
                  _createElementVNode("span", _hoisted_65, _toDisplayString(_unref(shop_building_error)), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_66, [
              _hoisted_67,
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(shop_telephone_error) }]),
                    placeholder: "電話番号(XXX-XXXX-XXXX)",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_isRef(shop_telephone) ? (shop_telephone).value = $event : null)),
                    disabled: _unref(same_as_salon_address)
                  }, null, 10, _hoisted_70), [
                    [_vModelText, _unref(shop_telephone)]
                  ]),
                  _createElementVNode("span", _hoisted_71, _toDisplayString(_unref(shop_telephone_error)), 1)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_72, [
      _createElementVNode("div", _hoisted_73, [
        _createElementVNode("div", _hoisted_74, [
          _hoisted_75,
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("div", _hoisted_77, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((bank_keyword).value = $event)),
                placeholder: "銀行",
                class: _normalizeClass(["p-3 mb-0.5 w-full border border-gray-300 rounded", { 'border-pink-600': bank_error.value }]),
                onInput: onBanknameChanged
              }, null, 34), [
                [_vModelText, bank_keyword.value]
              ]),
              (bank_suggests.value.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_78, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bank_suggests.value, (bank) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: bank.name,
                        onClick: ($event: any) => (onBankSelected(bank)),
                        class: "cursor-pointer hover:bg-gray-100 p-1"
                      }, _toDisplayString(bank.name), 9, _hoisted_79))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_80, _toDisplayString(bank_error.value), 1)
            ]),
            _createElementVNode("div", _hoisted_81, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((branch_keyword).value = $event)),
                placeholder: "支店",
                class: _normalizeClass(["p-3 mb-0.5 w-full border border-gray-300 rounded", { 'border-pink-600': branch_error.value }]),
                onInput: onBranchnameChanged
              }, null, 34), [
                [_vModelText, branch_keyword.value]
              ]),
              (branch_suggests.value.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_82, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(branch_suggests.value, (branch) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: branch.name,
                        onClick: ($event: any) => (onBranchSelected(branch)),
                        class: "cursor-pointer hover:bg-gray-100 p-1"
                      }, _toDisplayString(branch.name), 9, _hoisted_83))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_84, _toDisplayString(branch_error.value), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_85, [
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("label", _hoisted_87, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "form-radio",
                  name: "accountType",
                  value: "normal",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_isRef(account_type) ? (account_type).value = $event : null))
                }, null, 512), [
                  [_vModelRadio, _unref(account_type)]
                ]),
                _hoisted_88
              ]),
              _createElementVNode("label", _hoisted_89, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "form-radio",
                  name: "accountType",
                  value: "checking",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_isRef(account_type) ? (account_type).value = $event : null))
                }, null, 512), [
                  [_vModelRadio, _unref(account_type)]
                ]),
                _hoisted_90
              ]),
              _createElementVNode("label", _hoisted_91, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "form-radio",
                  name: "accountType",
                  value: "deposit",
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_isRef(account_type) ? (account_type).value = $event : null))
                }, null, 512), [
                  [_vModelRadio, _unref(account_type)]
                ]),
                _hoisted_92
              ]),
              _createElementVNode("span", _hoisted_93, _toDisplayString(_unref(account_type_error)), 1)
            ]),
            _createElementVNode("div", _hoisted_94, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(account_no_error) }]),
                placeholder: "口座番号",
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_isRef(account_no) ? (account_no).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(account_no)]
              ]),
              _createElementVNode("span", _hoisted_95, _toDisplayString(_unref(account_no_error)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("div", _hoisted_97, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(account_name_error) }]),
                placeholder: "口座名義",
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_isRef(account_name) ? (account_name).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(account_name)]
              ]),
              _createElementVNode("span", _hoisted_98, _toDisplayString(_unref(account_name_error)), 1)
            ])
          ])
        ])
      ])
    ]),
    (!salon.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
          _createElementVNode("div", _hoisted_100, [
            _createElementVNode("div", _hoisted_101, [
              _hoisted_102,
              _createElementVNode("div", _hoisted_103, [
                _createElementVNode("div", _hoisted_104, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(administrator_name_error) }]),
                    placeholder: "名前",
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_isRef(administrator_name) ? (administrator_name).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(administrator_name)]
                  ]),
                  _createElementVNode("span", _hoisted_105, _toDisplayString(_unref(administrator_name_error)), 1)
                ]),
                _createElementVNode("div", _hoisted_106, [
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(administrator_kana_error) }]),
                    placeholder: "名前カナ",
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_isRef(administrator_kana) ? (administrator_kana).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(administrator_kana)]
                  ]),
                  _createElementVNode("span", _hoisted_107, _toDisplayString(_unref(administrator_kana_error)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_108, [
                _createElementVNode("div", _hoisted_109, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(administrator_email_error) }]),
                    placeholder: "Eメール",
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_isRef(administrator_email) ? (administrator_email).value = $event : null))
                  }, null, 2), [
                    [_vModelText, _unref(administrator_email)]
                  ]),
                  _createElementVNode("span", _hoisted_110, _toDisplayString(_unref(administrator_email_error)), 1)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_111, [
      _createElementVNode("button", {
        class: "shadow bg-yellow-700 hover:bg-yellow-500 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded",
        type: "button",
        onClick: _withModifiers(onSave, ["prevent"])
      }, " 登録 ", 8, _hoisted_112),
      (message.value != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
            _hoisted_114,
            _createElementVNode("div", _hoisted_115, _toDisplayString(message.value), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})